export default __webpack_public_path__ + "static/media/apartment-storage.7e49c7c8.svg";